import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { teal, amber, yellow } from '@material-ui/core/colors';

import { UserController, ProductController, StripeController } from "controllers";
import { sortArrayPipe } from "shared/pipes";

export function getProducts(market, callback) {
    const tasks = []
    tasks.push(ProductController.getMissingItems(market));
    tasks.push(ProductController.getKeptItems(market));
    return Promise.all(tasks)
        .then(([missingItems, keptItems]) => {
            const totalItems = missingItems.concat(keptItems);

            if (totalItems.length === 0) {
                return Promise.reject("No missing items.")
            }

            const tasks = [];
            const cleanedItems = [];
            for (const item of totalItems) {
                if (item.currentUser) {
                    tasks.push(UserController.getUserById(item.currentUser));
                    cleanedItems.push(item);
                }
            }

            tasks.push(cleanedItems)
            return Promise.all(tasks);
        })
        .then((results) => {
            const missingItems = results.splice(-1).pop();
            const promises = [missingItems];

            for (const product of missingItems) {
                const user = results.find((u) => u.id === product.currentUser);
                product.user = user;
                promises.push(ProductController.getLogByBoxId(product.barcode, product.currentBox));
            }

            return Promise.all(promises);
        })
        .then((results) => {
            const [missingItems, ...logs] = results;
            for (const product of missingItems) {
                const log = logs.find((l) => l && (l.boxID === product.currentBox) && (l.barcode === product.barcode));

                product.log = log;
                product.addedToBox = log?.addedToBox;
            }

            const products = sortArrayPipe.transform(missingItems, 'addedToBox', false);
            callback(products);
        })
        .catch((err) => {
            console.error(err);
            callback([]);
        });
}

/**
 *
 * @param {*} missingItem
 * @param {*} callback
 */
export async function onMarkAsKept(missingItem, callback) {
    const stripe = missingItem.user.stripe;
    // update status of product (from 'missing' to 'kept')
    const status = 'kept';

    await ProductController.updateProductStatus(missingItem.barcode, status);
    const item = await UserController.getUserBoxItemByProductBarcode(missingItem.currentUser, missingItem.currentBox, missingItem.barcode);

    await ProductController.updateItem(missingItem.currentUser, missingItem.currentBox, item.id, status);

    await ProductController.updateProductLog(missingItem.barcode, missingItem.currentBox, "declared_kept");

    // add the stripe fields
    if (!stripe.single_item_subscriptions) {
        stripe.single_item_subscriptions = [];
    }

    const customerId = missingItem.user.stripe.stripe_id;
    const singleItemSubscription = { 'barcode': missingItem.barcode };
    if (customerId) {
        const country = localStorage.getItem('country');
        const result = await StripeController.createSingleItemSubscription(customerId, country);
        const subResult = result.data.result;

        singleItemSubscription.subscription_id = subResult.id;
        singleItemSubscription.status = subResult.status;
        singleItemSubscription.created_at = subResult.created;
        singleItemSubscription.created_from = 'Tidie';
    }

    stripe.single_item_subscriptions.push(singleItemSubscription);
    missingItem.user.stripe = stripe;
    const payload = { stripe };
    await UserController.addStripeSubscription(missingItem.currentUser, payload);
    callback();

    // TODO: surround all with try catch
    // throw new Error(error.message);
}


export const YellowButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(yellow[500]),
        backgroundColor: yellow[500],
        '&:hover': {
            backgroundColor: yellow[700],
        },
    },
}))(Button);

export const OrangeButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(amber['A400']),
        backgroundColor: amber['A400'],
        '&:hover': {
            backgroundColor: amber['A700'],
        },
    },
}))(Button);

export const GreenButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(teal['A400']),
        backgroundColor: teal['A400'],
        '&:hover': {
            backgroundColor: teal['A700'],
        },
    },
}))(Button);

export function validate(missingItem, newStatus, callback) {
    return ProductController.getProduct(missingItem.barcode)
        .then((retrievedProduct) => {
            if (retrievedProduct.status === 'kept') {
                return Promise.reject("Item status has been already updated.");
            }

            return ProductController.getProductLogByBoxId(missingItem.barcode, missingItem.currentBox)
        })
        .then((log) => {
            if (Boolean(log.investigated) && newStatus !== 'charged') {
                return Promise.reject("Item is already being investigated.");
            }

            callback(true);
        })
        .catch((error) => {
            console.log(error);
            callback(false, error);
        });
}
